import get from 'lodash.get';

export const selectUpdateProgress = state => get(state, 'models.updateProgress.data');
